module.exports = __webpack_public_path__ + "static/media/honor-img2.4b5ba88d.png";